(function () {
  var colourMap = {
    black: '#171717', white: '#ffffff', grey: '#8b8b8b', gray: '#8b8b8b',
    green: '#2f8b57', brown: '#8a5a3b', blue: '#2878c8', red: '#d63c32',
    yellow: '#f0cf32', orange: '#ef7e32', purple: '#7644a8', magenta: '#d23f9a',
    pink: '#ef8eaf', gold: '#c59a3a', silver: '#aeb5bd', beige: '#d7c4a4',
    natural: '#d7c4a4', 'rose gold': '#c98f7a', turquoise: '#2ca8a8'
  };

  function enhanceVariantChoices(root) {
    (root || document).querySelectorAll('.product-form__input').forEach(function (group) {
      var legend = group.querySelector('legend, .form__label');
      if (!legend || !/(colou?r|finish)/i.test(legend.textContent || '')) return;
      group.classList.add('m3dp-colour-group');

      group.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = group.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        if (!label) return;
        var name = (input.value || label.textContent || '').trim().toLowerCase();
        var matched = Object.keys(colourMap).find(function (key) { return name.indexOf(key) !== -1; });
        label.style.setProperty('--swatch-color', matched ? colourMap[matched] : '#ded9d4');
      });
    });
  }

  function attachPersonalisation() {
    var box = document.getElementById('m3dp-personalisation');
    if (!box) return;
    var form = document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]:not(.installment)');
    if (!form) return;
    var buttons = form.querySelector('.product-form__buttons');
    if (buttons) form.insertBefore(box, buttons);
    else form.appendChild(box);
    box.hidden = false;

    if (!form.dataset.m3dpValidationBound) {
      form.addEventListener('submit', function (event) {
        var invalid = Array.prototype.find.call(box.querySelectorAll('[required]'), function (field) {
          return !String(field.value || '').trim();
        });
        if (!invalid) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        invalid.focus();
        if (typeof invalid.reportValidity === 'function') invalid.reportValidity();
      }, true);
      form.dataset.m3dpValidationBound = 'true';
    }

    var input = box.querySelector('input[type="text"], textarea');
    var count = box.querySelector('[data-m3dp-count]');
    if (input && count) {
      var update = function () { count.textContent = String(input.value.length) + '/' + String(input.maxLength || 200); };
      input.addEventListener('input', update);
      update();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.add('m3dp-enhanced');
    enhanceVariantChoices(document);
    attachPersonalisation();
  });

  document.addEventListener('shopify:section:load', function (event) {
    enhanceVariantChoices(event.target);
    attachPersonalisation();
  });
})();